export enum EditingStatus {
  NotStarted = 'notStarted',
  RolesHaveUnassignedFields = 'rolesHaveUnassignedFields',
  ReadyToUse = 'readyToUse',
  InUse = 'inUse',
}
